<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="pestControlForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="pestControl" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                pestControlForm: () => import('../forms/PestControlForm'),
                pestControl: () => import('../editViews/PestControl'),
                headers: [
                    { text: 'Facility', value: 'facilityId', table: 'facilities', form: () => import('../forms/FacilityForm') },
                    { text: 'Station Number', value: 'stationNumber' },
                    { text: 'Placed On', value: 'placedOn', format: this.formatDate },
                    { text: 'Location Description', value: 'locationDescription' },
                    { text: 'Type Description', value: 'typeDescription' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    facilities: [],
                    items: []
                },
                sorting: [
                    { column: "placedOn", direction: "descending" },
                    { column: "stationNumber", direction: "ascending" },
                    { column: "facilityId", direction: "ascending" },
                ],
                itemsField: 'pestControls',
                editPageName: 'pestControl',
                apiMethod: 'PestControls',
                claimName: 'PestControls',
                formTitle: 'Pest Control',
                excelTitle: 'Pest Controls',
                hasEditPage: true,
            }
        },
    };
</script>
